import { createResourceKeys } from "@/lib/resource-context";

export const projectMembersKeys = createResourceKeys("project-members");
